module.exports = __webpack_public_path__ + "img/down_point_filtered_select.52f421b1.svg";